// extracted by mini-css-extract-plugin
module.exports = {"MakeContainer":"make-module--MakeContainer--27YII"};